<nz-table
  #virtualTable
  class="ui-infinite-scroll-table-wrapper"
  [nzData]="data"
  [nzLoading]="loading"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
  [nzLoadingIndicator]="loadingIndicatorRef"
  [nzScroll]="{ y: scrollHeight }"
  [nzVirtualItemSize]="virtualItemSize"
  [nzVirtualForTrackBy]="trackBy"
  [nzVirtualMaxBufferPx]="300"
  [nzVirtualMinBufferPx]="200"
>
  <thead>
    <tr>
      @if(isRowSelectionTable){
      <th
        class="ui-table-checkbox"
        [nzChecked]="checked"
        [nzDisabled]="rowSelectionDisabled"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"
        nzWidth="50px"
      ></th>
      } @for (column of tableColumns; track $index) {
      <th
        [nzShowSort]="column.sortable"
        [nzSortFn]="!!column.sortable"
        [nzWidth]="column?.width ?? null"
      >
        <ui-table-header-column [config]="column"></ui-table-header-column>
      </th>
      }
    </tr>
  </thead>
  <tbody>
    <ng-template nz-virtual-scroll let-rowData let-index="index">
      <tr>
        @if(isRowSelectionTable){
          <td
            class="ui-table-checkbox"
            [nzChecked]="setOfCheckedId.has(rowData | getFieldValue : rowSelectionByField)"
            [nzDisabled]="rowSelectionDisabled"
            (nzCheckedChange)="onItemChecked(rowData, $event)"
          ></td>
        }
        @for (column of tableColumns; track $index) {
          <td>
            <ui-table-body-column
              [index]="index"
              [config]="column"
              [data]="rowData"
              (updateTableData)="onUpdateTableData()"
              (rowClicked)="onRowClicked($event, rowData)"
            ></ui-table-body-column>
          </td>
        }
      </tr>
    </ng-template>
  </tbody>
</nz-table>

<ng-template #loadingIndicatorRef>
  <div class="loading-indicator-wrapper">
    <ui-loading [text]="'Загрузка данных...'"></ui-loading>
  </div>
</ng-template>
